import { arc, pie } from 'd3-shape';
import { useMemo } from 'react';

interface DonutSlice {
  label: string;
  value: number;
  color: string;
}

interface DonutProps {
  data: DonutSlice[];
  size?: number;
  thickness?: number;
}

export function Donut({ data, size = 200, thickness = 28 }: DonutProps) {
  const radius = size / 2;
  const slices = useMemo(() => {
    const layout = pie<DonutSlice>()
      .value((d) => d.value)
      .sort(null);
    const a = arc<ReturnType<typeof layout>[number]>()
      .innerRadius(radius - thickness)
      .outerRadius(radius);
    return layout(data).map((d) => ({ d, path: a(d) ?? '' }));
  }, [data, radius, thickness]);

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img">
      <g transform={`translate(${radius} ${radius})`}>
        {slices.map(({ d, path }) => (
          <path key={d.data.label} d={path} fill={d.data.color} />
        ))}
      </g>
    </svg>
  );
}
